module.exports = __webpack_public_path__ + "img/2x.bd7fc60.jpg";